import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {
    SpinnerStatusActions,
    SpinnerStatusActionsTypes
} from "@ispm-client/modules/bpmn-modeler/store/actions/spinner-status.actions";


export function spinnerStatus(state = initialState.spinnerStatus, action: SpinnerStatusActions): boolean {
    switch (action.type) {
        case SpinnerStatusActionsTypes.TOGGLE_SPINNER: {
            return !state;
        }
        default: {
            return state;
        }
    }
}

